function setCookie(name, value, days = 1) {
  const ONE_DAY_MS = 24 * 60 * 60 * 1000;

  const expires = new Date(Date.now() + days * ONE_DAY_MS).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

function getCookie(name) {
  const match = document.cookie
    .split('; ')
    .find(row => row.startsWith(name + '='));

  return match ? match.split('=')[1] : null;
}

const isLen4prep = window.location.pathname.includes('len4prep');
const isHcp =
  (!isLen4prep && getCookie('entry-popup-hcp') === 'hcp') ||
  (isLen4prep && getCookie('entry-popup-hcp-len4prep') === 'hcp');

function loadDocIframe() {
  const iframe = document.querySelector('#doc-viewer');
  if (iframe && iframe.contentWindow) iframe.contentWindow.postMessage('load_doc');
}

function entryPop() {
  const js_entry_pop = document.querySelector('.js-entry-pop');

  if (!js_entry_pop) return;

  js_entry_pop.classList.remove('is-hidden');
  document.body.classList.add('overflow-x-hidden');

  document.querySelectorAll('.js-entry-pop-btn').forEach(btn => {
    btn.addEventListener('click', event => {
      event.preventDefault();

      const type = btn.dataset.type;
      const link = btn.dataset.link;

      if (type === 'hcp') {
        const cookieName = isLen4prep ? 'entry-popup-hcp-len4prep' : 'entry-popup-hcp';
        setCookie(cookieName, 'hcp'); // 1 day
        js_entry_pop.classList.add('is-hidden');
        loadDocIframe();
      } else {
        window.location = link;
      }

      document.body.classList.remove('overflow-x-hidden');
    });
  });
}

if (!isHcp) {
  entryPop();
} else {
  loadDocIframe();
}


// WEBPACK FOOTER //
// ./src/assets/js/project/entry-modal-vanilla.js